const containerJobTitle = {
  width: '100%',
  background: '#f6f7fc',
  height: 'auto',
  minHeight: '100vh',
};

const searchContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '95%',
  margin: 'auto',
  marginBottom: '3rem',
  justifyContent: 'space-between',
};

const findContainer = {
  width: '50%',
  justifyContent: 'flex-end',
};

export default {
  containerJobTitle,
  searchContainer,
  findContainer,
};
